export enum AccountTransactionReason{
    Deposit,
    Withdraw,
    Exchange,
    ExchangeCancel,
    BranchTransfer,
    BranchMoneyEntry,
    Collection,
    BranchMoneyExit,
    CaseCounting,
    Virman,
    Sales,
    ProductionCost,
    RawMaterialPurchase,
    Expense,
    Income,
    ProductPurchase,
    Import,
    BankAccountTransaction,
    TcknVknMatch,
    BankPayment,
    IbanMatch,
    BankAutoCustomer,
    BankManualMatch,
    NameMatch,
    BankOpeningBalance,
    // "Kasadan aktar": ürüne/ara mamüle dönüşen malın işçilik hariç bedelinin kasadan çıkışı
    ProductTransfer,
    // Toptancıdan toplu alım: grubun toptancıya alacağı ve seçilen kasaya girişi
    BulkPurchase
}
